module.exports = __webpack_public_path__ + "p1_img1.png?5c0678d35d6e77eb3f5dc014f695938b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p1/p1_img1.png
// module id = 48
// module chunks = 0